<button *ngIf="mode === dlgMode.button && !popup"
  [class]="icon ? 'btn btn-default btn-sm' : 'nrk-button'" 
  style="margin:3px !important" 
  [title]="title"
  (click)="popup = !popup">
  <i *ngIf="icon"[class]="icon"></i>{{icon ? '' : iconText}}
</button>


<input *ngIf="mode === dlgMode.input"
  type="text"
  class="form-control form-control-sm"
  style="margin:3px !important" 
  [title]="title"
  [value]="getText('code', $any(abstractItem))"
  (click)="popup = !popup"
/>

<!-- <ng-container *ngIf="popup">

  <ng-template #docselect>

  <div class="container">
    <button class="nrk-button" style="position:absolute;left:1em;top:1em" (click)="clearFilter()">Clear filter</button>
    <button *ngIf="buttonText" class="nrk-button" style="position:absolute;right:6em;top:1em" (click)="onButton()">{{buttonText}}</button>
    <button class="nrk-button" style="position:absolute;right:1em;top:1em" (click)="hide()">Cancel</button>
    <h4>{{title}}</h4>
    <section class="container" [ngStyle]="style">
      <table>
        <tr class="sticky">
          <th *ngFor="let col of columns">
            <div class="column-header">
              <div class="title pseudo-link" (click)="onSort(col)">{{col.title}}</div>
              <div class="filter"><input placeholder="Search..." [(ngModel)]="col.search" (keyup)="onFilter()" /></div>
            </div>
          </th>
        </tr>
        <tr *ngFor="let item of filtered" (click)="onSelect(item)">
          <td *ngFor="let col of columns">{{getText(col.id, item)}}</td>
        </tr>
      </table>
    </section>
  </div>

  </ng-template>
</ng-container> -->


<ng-container *ngIf="popup || mode === dlgMode.window">
  <div [class]="mode !== dlgMode.window ? 'select-container' : 'plain-container'" [ngStyle]="style">
    <!-- <button class="nrk-button" style="position:absolute;left:1em;top:1em" (click)="clearFilter()">Clear filter</button>
    <button *ngIf="buttonText" class="nrk-button" style="position:absolute;right:6em;top:1em" (click)="onButton()">{{buttonText}}</button>
    <button class="nrk-button" style="position:absolute;right:1em;top:1em" (click)="hide()">Cancel</button> -->
    <div class="header">
      <div class="buttons-title">
        <div style="position:relative">
          <button class="nrk-button" style="position:absolute;top:1em;left:1em" (click)="clearFilter()">Clear filter</button>
          <button *ngIf="multiselect" class="nrk-button" style="position:absolute;top:1em;left:7em" (click)="selectAll()">Select all</button>
          <div style="position:absolute;top:1em;right:1em">
            <div *ngIf="title === 'Finished Products'" style="display:flex;float:left;align-items:center;padding-right:1rem;"><input type="checkbox" [(ngModel)]="showDisabled" (ngModelChange)="ngOnInit()"/>&nbsp;show&nbsp;disabled</div>
            <button *ngIf="buttonText" class="nrk-button mr-2" (click)="onButton()">{{buttonText}}</button>
            <button *ngIf="multiselect" class="nrk-button mr-2" (click)="ok()">Ok</button>
            <button *ngIf="mode !== dlgMode.window" class="nrk-button" (click)="hide()">Cancel</button>
          </div>
        </div>
        <h4>{{title}}</h4>
      </div>
      <div *ngIf="showBusinessInput" class="business-input">
        <ngx-doc-form-filter-select class="fullwidth" placeholder="Customer..." [value]="businessId" (valueChange)="onBusinessIdChanged($event)" [options]="data.businessOptions"></ngx-doc-form-filter-select>
      </div>
      <div *ngIf="showPagination" class="mx-auto pagination-container">
        <pagination-controls (pageChange)="docPage = $event" [id]="paginationId"></pagination-controls>
      </div>
    </div>
    <div class="content-table">
      <table>
        <tr class="sticky">
          <th *ngFor="let col of columns">
            <div class="column-header">
              <div class="title pseudo-link" (click)="onSort(col)">{{col.title}}</div>
              <div class="filter"><input placeholder="Search..." [(ngModel)]="col.search" (keyup)="onFilter()" /></div>
            </div>
          </th>
        </tr>
        <ng-container *ngIf="showPagination && filtered?.length">
          <tr *ngFor="let item of filtered | paginate: { id: paginationId, itemsPerPage: 10, currentPage: docPage }" (click)="onSelect(item, $event)" [ngStyle]="getStyle(item)">
            <!-- <td *ngFor="let col of columns">{{getText(col.id, item)}}</td> -->
            <td *ngFor="let col of columns">{{getText(col.id, item)}}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!showPagination && filtered?.length">
          <tr *ngFor="let item of filtered" (click)="onSelect(item, $event)" [ngStyle]="getStyle(item)">
            <!-- <td *ngFor="let col of columns">{{getText(col.id, item)}}</td> -->
            <td *ngFor="let col of columns">{{getText(col.id, item)}}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!filtered?.length">
          <tr><td [attr.colspan]="columns.length"><div class="text-center my-3">nothing to display</div></td></tr>
        </ng-container>
      </table>
    </div>
  </div>
</ng-container>
